import mProductArchiveSkeleton1 from "./ProductArchiveSkeleton1.vue";

export const ProductArchiveSkeleton = {
    mProductArchiveSkeleton1,
}